import type { BlockDTO } from '@next-space/fe-api-idl';

export const allBlocks: { blocks: Record<string, BlockDTO> } = {
  blocks: {},
};
